import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SurveyKpiProgress } from 'src/app/models/survey.model';

@Component({
  selector: 'app-survey-kpi-card',
  templateUrl: './survey-kpi-card.component.html',
  styleUrl: './survey-kpi-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatProgressBarModule],
})
export class SurveyKpiCardComponent {
  readonly label = input.required<string>();
  readonly value = input<string | number | null>(null);
  readonly hint = input<string | null>(null);
  readonly progress = input<SurveyKpiProgress | null>(null);
  readonly icon = input<string | null>(null);

  protected readonly display_value = computed((): string => {
    const value = this.value();

    if (value === null || value === undefined || value === '') {
      return '—';
    }

    return String(value);
  });

  protected readonly progress_percent = computed((): number => {
    const progress = this.progress();

    if (!progress || progress.total <= 0) {
      return 0;
    }

    return Math.min(100, Math.round((progress.completed / progress.total) * 100));
  });

  protected readonly progress_label = computed((): string | null => {
    const progress = this.progress();

    if (!progress) {
      return null;
    }

    return `${progress.completed}/${progress.total}`;
  });
}
